/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  AutoSuggestionListingResponse,
  AutoSuggestionPlaceResponse,
  CommonPropertySuggestParams,
  CommonSuggestParams,
  GetPlaceDetailsForPropertyEngineParams,
  GetPlaceDetailsV2Params,
  PlaceDetails,
  PlaceDetailsExtended
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Suggest placeIds for a given input using new Place API
 */
export const commonSuggest = (
    params: CommonSuggestParams,
 options?: SecondParameter<typeof customInstance<AutoSuggestionPlaceResponse[]>>,) => {
      return customInstance<AutoSuggestionPlaceResponse[]>(
      {url: `/api/v2/autosuggestion/suggest`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Return the place details with a given place id
 */
export const getPlaceDetailsForPropertyEngine = (
    params: GetPlaceDetailsForPropertyEngineParams,
 options?: SecondParameter<typeof customInstance<PlaceDetailsExtended>>,) => {
      return customInstance<PlaceDetailsExtended>(
      {url: `/api/v2/autosuggestion/property-engine/details`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Suggest properties for a given input.
 */
export const commonPropertySuggest = (
    params: CommonPropertySuggestParams,
 options?: SecondParameter<typeof customInstance<AutoSuggestionListingResponse[]>>,) => {
      return customInstance<AutoSuggestionListingResponse[]>(
      {url: `/api/v2/autosuggestion/listing/suggest`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Return the place details with a given place id
 */
export const getPlaceDetailsV2 = (
    params: GetPlaceDetailsV2Params,
 options?: SecondParameter<typeof customInstance<PlaceDetails>>,) => {
      return customInstance<PlaceDetails>(
      {url: `/api/v2/autosuggestion/details`, method: 'GET',
        params
    },
      options);
    }
  export type CommonSuggestResult = NonNullable<Awaited<ReturnType<typeof commonSuggest>>>
export type GetPlaceDetailsForPropertyEngineResult = NonNullable<Awaited<ReturnType<typeof getPlaceDetailsForPropertyEngine>>>
export type CommonPropertySuggestResult = NonNullable<Awaited<ReturnType<typeof commonPropertySuggest>>>
export type GetPlaceDetailsV2Result = NonNullable<Awaited<ReturnType<typeof getPlaceDetailsV2>>>
